import { useEffect, } from 'react'

export const switchErrorCode = (errorCode: number, setIsError: (arg: boolean) => void, setErrorCode: (arg: number) => void) => {
    useEffect(() => {
        switch (errorCode) {
            case 3:
            case 4:
            case 6:
            case 11:
            case 16:
            case 17:
            case 115:
                setIsError(true)
                setTimeout(() => {
                    setErrorCode(0)
                }, 1000)
                break

            default:
                setIsError(false)
                break
        }
    }, [errorCode])
}